export const options_readingPane_quickSetting_right = "uWd";
export const options_readingPane_quickSetting_bottom = "vWd";
export const options_readingPane_quickSetting_classic = "wWd";
export default {options_readingPane_quickSetting_right,options_readingPane_quickSetting_bottom,options_readingPane_quickSetting_classic};